import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/angular';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import { NgxPermissionsModule } from 'ngx-permissions';
import { FacebookModule } from 'ngx-facebook';
import { GoogleMapsModule } from '@angular/google-maps';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { InputSwitchModule } from 'primeng/inputswitch';
import { AppRoutingModule } from './app-routing.module';
import { ToastModule } from "primeng/toast";
import { MessageService } from 'primeng/api';

import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { NavigationModule } from "./navigation/navigation.module";
import { ComponentsModule } from './components/components.module';
import { ChangePasswordComponent } from "./change-password/change-password.component";
import { ReportsComponent } from './reports/reports.component';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { AppService } from '@services/app.service';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';
import { PortalModule } from '@angular/cdk/portal';
import { UserPhoneNumberFormComponent } from './user-phone-number-form/user-phone-number-form.component';
import { PhoneNumberModalFormComponent } from './phone-number-modal-form/phone-number-modal-form.component';
import { NgxIntlTelInputModule } from '@capgo/ngx-intl-tel-input';

import { environment } from '@environments/environment';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    AppComponent,
    ChangePasswordComponent,
    ReportsComponent,
    UserPhoneNumberFormComponent,
    PhoneNumberModalFormComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    CoreModule,
    ComponentsModule,
    HttpClientModule,
    NavigationModule,
    NgbModule,
    NgxPermissionsModule.forRoot(),
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    NgbAccordionModule,
    ReactiveFormsModule,
    FormsModule,
    ToastModule,
    FacebookModule.forRoot(),
    !environment.production ? StoreDevtoolsModule.instrument({ maxAge: 50 }) : [],
    PortalModule,
    NgxIntlTelInputModule,
    InputSwitchModule
  ],
  providers: [
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({ showDialog: false }),
    },
    { provide: Sentry.TraceService, deps: [Router] },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
    MessageService,
    AppService,
    { provide: Window,useValue: window }
  ],
  schemas: [],
  bootstrap: [AppComponent]
})
export class AppModule { }

